type Person = {
  firstName: string
  lastName: string
};

export const getPersonInitials = (person: Person): string => {
  return `${person.firstName?.charAt(0)?.toUpperCase()}${person.lastName?.charAt(0)?.toUpperCase()}`;
};
